import s from "./AdditionalInformation.less";
import React, { useEffect, useState } from "react";
import clsx from "clsx";

type Props = {
  fieldsConfig: {
    isDatePicker: boolean;
    name: string;
    defaultValue: Date | string;
    label: string;
  }[];
  isMoreDetails: Boolean;
};
const AdditionalInformation = ({ fieldsConfig, isMoreDetails }: Props) => {
  const [showWindow, setShowWindow] = useState(false);

  useEffect(() => {
    if (isMoreDetails) {
      setShowWindow(true);
    } else {
      setShowWindow(false);
    }
  }, [isMoreDetails]);

  return (
    <div className={clsx(s.wrapper, showWindow ? s.active : null)}>
      {fieldsConfig.map((formElement) => (
        <div key={formElement.name} className={s.item_edit}>
          <span className={clsx(s.label, showWindow ? s.active_label : null)}>
            {formElement.label}
          </span>
          <span className={clsx(s.label, showWindow ? s.active_label : null)}>
            {formElement.defaultValue.toLocaleString("ru-RU", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            })}
          </span>
        </div>
      ))}
    </div>
  );
};

export default AdditionalInformation;
